import {
  GridColDef,
  GridFilterOperator,
  getGridStringOperators,
} from "@mui/x-data-grid-premium";

const normalize = (value: unknown) =>
  String(value ?? "")
    .trim()
    .toLocaleLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "");

export const getCaseInsensitiveStringOperators = (): GridFilterOperator[] => {
  return getGridStringOperators().map((operator) => {
    switch (operator.value) {
      case "contains":
        return {
          ...operator,
          getApplyFilterFn: (filterItem) => {
            const filterValue = normalize(filterItem.value);
            if (!filterValue) return null;

            return (value) => normalize(value).includes(filterValue);
          },
        };

      case "doesNotContain":
        return {
          ...operator,
          getApplyFilterFn: (filterItem) => {
            const filterValue = normalize(filterItem.value);
            if (!filterValue) return null;

            return (value) => !normalize(value).includes(filterValue);
          },
        };

      case "equals":
        return {
          ...operator,
          getApplyFilterFn: (filterItem) => {
            const filterValue = normalize(filterItem.value);
            if (!filterValue) return null;

            return (value) => normalize(value) === filterValue;
          },
        };

      case "doesNotEqual":
        return {
          ...operator,
          getApplyFilterFn: (filterItem) => {
            const filterValue = normalize(filterItem.value);
            if (!filterValue) return null;

            return (value) => normalize(value) !== filterValue;
          },
        };

      case "startsWith":
        return {
          ...operator,
          getApplyFilterFn: (filterItem) => {
            const filterValue = normalize(filterItem.value);
            if (!filterValue) return null;

            return (value) => normalize(value).startsWith(filterValue);
          },
        };

      case "endsWith":
        return {
          ...operator,
          getApplyFilterFn: (filterItem) => {
            const filterValue = normalize(filterItem.value);
            if (!filterValue) return null;

            return (value) => normalize(value).endsWith(filterValue);
          },
        };

      default:
        return operator;
    }
  });
};

export const withCaseInsensitiveStringFilters = <R extends object>(
  col: GridColDef<R>
): GridColDef<R> => ({
  ...col,
  filterOperators: getCaseInsensitiveStringOperators(),
});